// i18n key for an application access name (the sidebar's section labels), e.g. "videoplaylists"
// -> "sidebar.videoPlaylists"; unknown names fall back to themselves
const ACCESS_LABEL_KEYS: Record<string, string> = {
  collaborators: 'sidebar.collaborators',
  collaboratorfunctions: 'sidebar.collaboratorFunctions',
  departments: 'sidebar.departments',
  locations: 'sidebar.locations',
  radios: 'sidebar.radios',
  videoplaylists: 'sidebar.videoPlaylists',
  videos: 'sidebar.videos',
  podcasts: 'sidebar.podcasts',
  banners: 'sidebar.banners',
  events: 'sidebar.events',
  offerings: 'sidebar.offerings',
  feed: 'sidebar.feed',
}

export function accessLabelKey(access: string): string {
  return ACCESS_LABEL_KEYS[access] ?? access
}
